/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HomeownershipPageRequest
 */
export interface HomeownershipPageRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipPageRequest
     */
    token: string;
}

/**
 * Check if a given object implements the HomeownershipPageRequest interface.
 */
export function instanceOfHomeownershipPageRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function HomeownershipPageRequestFromJSON(json: any): HomeownershipPageRequest {
    return HomeownershipPageRequestFromJSONTyped(json, false);
}

export function HomeownershipPageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipPageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function HomeownershipPageRequestToJSON(value?: HomeownershipPageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

